import { InfoBlock as DirectInfoBlock, type InfoBlockProps } from '@direct-frontend/components'; // eslint-disable-line no-restricted-imports -- Разрешаем импортировать InfoBlock
import { isMobile } from '@direct-frontend/platform-code';

export const InfoBlock = (props: InfoBlockProps) => {
    const { type, ...otherProps } = props;

    /**
     * Есть особенность, что в текущем виде в библиотеке компонентов InfoBlock с иконкой (type="icon") отображается в две линии (вертикально),
     * А нам нужно в одну — реализуем это, избавляясь от иконки
     */
    if (type === 'icon' && isMobile()) {
        return <DirectInfoBlock {...otherProps} type={undefined} />;
    }

    return <DirectInfoBlock {...props} />;
};
